export default function InlineStackItem({ shrink0, grow1, selfEnd, children }) {
    let finalClassName = 'inline-stack-item'
    if (shrink0) finalClassName += ' shrink-0'
    if (grow1) finalClassName += ' grow-1'
    if (selfEnd) finalClassName += ' self-end'
    return <div className={finalClassName}>{children}</div>
}
